// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"fab3c72643c8c47b69cf","655":"c4648f57189cd2b9dbc5"}[chunkId] + ".js";
};